import { createSelector } from 'react-sweet-state';

import { isApiComment } from 'src/components/conversation-provider/types';
import { BBTask } from 'src/components/types/src/task';
import { getTasksSlice } from 'src/selectors/task-selectors';

import { PRSelector, getAllRawComments } from '.';

export const getNumPendingComments: PRSelector<number> = createSelector(
  getAllRawComments,
  rawComments => {
    return rawComments.filter(
      c => (!isApiComment(c) || !c.deleted) && c.pending
    ).length;
  }
);

export const getPendingTasks: PRSelector<BBTask[]> = createSelector(
  getTasksSlice,
  tasksSlice => {
    return tasksSlice.items.filter(t => t.pending);
  }
);

export const getPendingTaskCount: PRSelector<number> = createSelector(
  getPendingTasks,
  pendingTasks => {
    return pendingTasks.length;
  }
);

export const getIsReviewInProgress: PRSelector<boolean> = createSelector(
  getNumPendingComments,
  getPendingTaskCount,
  (numPendingComments, numPendingTasks) =>
    numPendingComments + numPendingTasks > 0
);
